import type { ApolloCache } from '@apollo/client';

import { GET_CUSTOMER } from 'graphql/queries/getCustomer';
import type { Query } from 'types/generatedSchemaTypes';

/**
 * Drops a deleted payment card from the cached GET_CUSTOMER paymentCards list
 * so occupancy helpers (hasActiveAdyenWalletOfType) do not keep treating the
 * card as present when a best-effort customer refresh fails after delete.
 */
export const removePaymentCardFromCustomerCache = (
  cache: Pick<ApolloCache<object>, 'readQuery' | 'writeQuery'>,
  cardId: string
): void => {
  try {
    const existing = cache.readQuery<Query>({ query: GET_CUSTOMER });
    const customer = existing?.readAppCustomer;
    if (!customer) {
      return;
    }
    cache.writeQuery({
      query: GET_CUSTOMER,
      data: {
        readAppCustomer: {
          ...customer,
          paymentCards: (customer.paymentCards ?? []).filter(
            (card) => card?.cardId !== cardId
          ),
        },
      },
    });
  } catch {
    // GET_CUSTOMER may not be in the cache yet — caller still refreshes best-effort.
  }
};
